import React, { useState } from 'react';

export default function TextInput({
  curValue,
  updateValue,
  formData,
  category,
  colSize,
  placeholder
}) {
  const [value, setValue] = useState(curValue);

  const handleChange = (e) => {
    setValue(e.target.value);
    updateValue({ ...formData, [category]: e.target.value });
  };

  // Send Value to Parent
  const style = `grid__col-lg-${colSize} u--padding-0`;

  return (
    <div className={style}>
      <div className="form__field form__field--required form__field--error u--margin-bottom-0">
        <input
          type="text"
          className="utm__form__input"
          value={value}
          onChange={(event) => handleChange(event)}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
}
